import type { Dict } from "../core.js";
import type { appHome as vi } from "../vi/appHome.js";

export const appHome: Dict<typeof vi> = {
  eyebrow: "App · {slug}",
  ownPages: "App-specific pages",
  metrics: "Metrics for this app",
  metricsHint: "Opens the shared Metrics pages with {name} preselected. You can switch to « {allApps} » there.",
};
